// extracted by mini-css-extract-plugin
export default {"root":"projectSetup_root__S+sFT","partTitle":"projectSetup_partTitle__9eEpa","partTabs":"projectSetup_partTabs__ZMCgg","partMain":"projectSetup_partMain__Be7qL"};